"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.optionBase = exports.StyledUncheckIcon = exports.StyledCheckIcon = exports.StepChecksOptionWrapper = exports.OptionUncheck = exports.OptionCheck = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _Icon = _interopRequireDefault(require("../../Icon"));
var _palette = require("../../../styles/palette");
var _constants = require("./constants");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var CHECKMARK = _constants.OPTION_TYPES.CHECKMARK,
  CLOSE = _constants.OPTION_TYPES.CLOSE;
var StepChecksOptionWrapper = exports.StepChecksOptionWrapper = _styledComponents["default"].div.withConfig({
  displayName: "styles__StepChecksOptionWrapper",
  componentId: "sc-1icvhfn-0"
})(["display:flex;width:100%;justify-content:center;"]);
var optionBase = exports.optionBase = "\n  border-radius: 5px;\n  width: 56px;\n  height: 56px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  @media(max-width: 1100px){\n    width:40px;\n    height: 40px;\n  }\n";
var OptionCheck = exports.OptionCheck = _styledComponents["default"].div.withConfig({
  displayName: "styles__OptionCheck",
  componentId: "sc-1icvhfn-1"
})(["", " border:2px solid ", ";margin:15px 0 15px 0;background-color:", ";"], optionBase, _palette.checklistColors.green, function (_ref) {
  var checked = _ref.checked;
  return checked ? _palette.checklistColors.green : _palette.checklistColors.white;
});
var OptionUncheck = exports.OptionUncheck = _styledComponents["default"].div.withConfig({
  displayName: "styles__OptionUncheck",
  componentId: "sc-1icvhfn-2"
})(["", " border:2px solid ", ";margin:15px 0 15px 15px;background-color:", ";"], optionBase, _palette.checklistColors.red, function (_ref2) {
  var unChecked = _ref2.unChecked;
  return unChecked ? _palette.checklistColors.red : _palette.checklistColors.white;
});
var StyledCheckIcon = exports.StyledCheckIcon = (0, _styledComponents["default"])(_Icon["default"]).attrs({
  name: CHECKMARK
}).withConfig({
  displayName: "styles__StyledCheckIcon",
  componentId: "sc-1icvhfn-3"
})(["height:25px;color:", ";"], function (_ref3) {
  var checked = _ref3.checked;
  return checked ? _palette.checklistColors.white : _palette.checklistColors.green;
});
var StyledUncheckIcon = exports.StyledUncheckIcon = (0, _styledComponents["default"])(_Icon["default"]).attrs({
  name: CLOSE
}).withConfig({
  displayName: "styles__StyledUncheckIcon",
  componentId: "sc-1icvhfn-4"
})(["height:15px;color:", ";"], function (_ref4) {
  var unChecked = _ref4.unChecked;
  return unChecked ? _palette.checklistColors.white : _palette.checklistColors.red;
});
//# sourceMappingURL=styles.js.map